import React, { useState } from 'react';

const sanitizeInput = (input) => {
  const div = document.createElement('div');
  div.textContent = input;
  return div.innerHTML;
};

export default function ContactMe() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [errors, setErrors] = useState({});
  const [formStatus, setFormStatus] = useState('');

  const validateField = (name, value) => {
    let error = '';
    if (name === 'name' && !value.trim()) {
      error = 'Name is required';
    }
    if (name === 'email' && !value.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)) {
      error = 'Invalid email address';
    }
    if (name === 'message' && value.length < 10) {
      error = 'Message must be at least 10 characters long';
    }
    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const sanitizedValue = sanitizeInput(value);

    setFormData({ ...formData, [name]: sanitizedValue });

    const error = validateField(name, sanitizedValue);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error || undefined,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = Object.keys(formData).reduce((acc, key) => {
      const error = validateField(key, formData[key]);
      if (error) acc[key] = error;
      return acc;
    }, {});

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      try {
        console.log("formData", formData);
        console.log("Sending query to the server...");
        const response = await fetch('/api/sendQuery', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
        console.log("Response", response);
        const result = await response.json();

        if (result.success) {
          setFormStatus('Query sent successfully!');
          setFormData({ name: '', email: '', message: '' }); // Reset form
        } else {
          setFormStatus('Failed to send query, please try again.');
        }
      } catch (error) {
        console.error('Error:', error);
        setFormStatus('An error occurred. Please try again later.');
      }
    }
  };

  return (
    <div className="contact-page flex justify-center items-center min-h-screen bg-[#f3f7f5]">
      <div className="contact-container bg-white shadow-lg rounded-lg p-8 md:p-16 max-w-lg w-full">
        <h2 className="text-3xl font-semibold mb-6 text-gray-800">Contact Me</h2>
        <form className="space-y-6" onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label htmlFor="name" className="block text-sm font-medium text-gray-700">
              Your Name
            </label>
            <input
              type="text"
              name="name"
              id="name"
              value={formData.name}
              onChange={handleChange}
              className={`input-field w-full p-3 rounded border ${
                errors.name ? 'border-red-500' : 'border-gray-300'
              } focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500`}
            />
            {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
          </div>

          <div className="form-group">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Your Email
            </label>
            <input
              type="email"
              name="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              className={`input-field w-full p-3 rounded border ${
                errors.email ? 'border-red-500' : 'border-gray-300'
              } focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500`}
            />
            {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
          </div>

          <div className="form-group">
            <label htmlFor="message" className="block text-sm font-medium text-gray-700">
              Your Message
            </label>
            <textarea
              name="message"
              id="message"
              value={formData.message}
              onChange={handleChange}
              className={`input-field w-full p-3 rounded border ${
                errors.message ? 'border-red-500' : 'border-gray-300'
              } focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 h-40`}
            />
            {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}
          </div>

          <button
            type="submit"
            className="submit-btn w-full py-3 px-6 bg-indigo-600 text-white rounded hover:bg-indigo-500 transition duration-300 focus:ring-4 focus:ring-indigo-400 focus:outline-none"
          >
            Send Message
          </button>
        </form>

        {formStatus && (
          <p className={`mt-4 text-sm ${formStatus.includes('success') ? 'text-green-500' : 'text-red-500'}`}>
            {formStatus}
          </p>
        )}
      </div>
    </div>
  );
}
